import React from 'react';

import { Alert } from '@freelancelabs/components';

import { Refusal } from '../pages/accounts/portalAccess';

interface Props {
    refusal: Refusal;
}

/**
 * A refusal from the API, rendered as the information it is rather than as a crash.
 *
 * It was private to `PortalAccessDialog` until PCG-79 needed the same block on six
 * more mutations. Shared here rather than copied: the second copy is where the
 * technical detail stops being rendered, and a refusal whose detail is dropped
 * leaves the support desk with nothing.
 *
 * `role="alert"` because it appears **after** the click, on a dialog the operator is
 * already reading: without it the answer to their action is announced by nothing.
 *
 * It takes a read `Refusal` and not the error: which vocabulary reads a code is the
 * caller's business (`refusalOf` for the portal access, `catalogueRefusalOf` for the
 * catalogues), and passing the error would have made this component pick one.
 */
const RefusalNotice = ({ refusal }: Props) => (
    <div role="alert">
        <Alert type="danger" title={refusal.title}>
            <p className="text-sm">{refusal.guidance}</p>
            {refusal.detail && (
                <p className="mt-2 break-words rounded-md border border-border-norm bg-background-weak p-2 font-mono text-xs">
                    {refusal.detail}
                </p>
            )}
        </Alert>
    </div>
);

export default RefusalNotice;
